import { Text } from "../../../../ui/components/Text";

export function PlaceholderPage({
  title,
  description = "This area is under development and will be available in a future release.",
}: {
  title: string;
  description?: string;
}) {
  return (
    <div style={{ padding: "32px 24px", fontFamily: "Inter, sans-serif" }}>
      <Text level="h1" color="primary" weight="bold" style={{ marginBottom: 8 }}>
        {title}
      </Text>
      <Text level="body-medium" style={{ color: "#6B7280" }}>
        {description}
      </Text>
    </div>
  );
}
